<template>
  <div id="app" class="absolute w-full h-full">
    <div id="nav" class="" v-if="isAuthenticated">
      
      <div class="bg-teal-500 px-6 py-2 flex justify-between text-sm text-white">
        <div class="flex items-center">
          <router-link to="/" class="inline-block"><img src="@/assets/unither-logo-white.svg" class="h-4"/></router-link>
          <span class="opacity-50 inline-block ml-2 pl-2 border-l">{{ $store.state.authUser }}</span>
        </div>

        <div>
          <a href="https://unither.cpixapps.com/admin" class="mr-2 hover:underline">Admin Portal</a>|<button @click="logout" class="ml-2 hover:underline">Logout</button>
        </div>
        
      </div>
      <div class="px-6 py-2 border-b text-gray-700 text-sm flex justify-between">
      <div >
            <router-link to="/" class="mr-1"><span class="hover:underline">Packaging Portal</span></router-link> /
            <router-link  class="mr-1" v-for="breadcrumb in breadcrumbs" :key="breadcrumb.path" :to="breadcrumb.path"><span class="hover:underline">{{ breadcrumb.label | capitalize }}</span> /</router-link>
        </div>
        
      </div>
      
    </div>
    <router-view v-if="isAuthenticated" class="min-h-full" />
    <footer  v-if="isAuthenticated" class="bg-gray-500 py-4 text-white text-sm text-center">
        <p class="text-gray-300">&copy;2019 UNITHER Pharmaceuticals</p>
    </footer>
    <login v-if="!isAuthenticated && mounted"></login>
  </div>
</template>

<script>

import Login from "./components/Login.vue"
import UserWidget from "./components/UserWidget.vue"

export default {

  components: {
    Login,
    UserWidget
  },

  mounted: async function(){
    var authenticated;

      await this.$api.checkAuthenticationStatus().then((status) => {

        var userStatus = {
          authUser: this.$api.getUsername(),
          isAuthenticated: status
        }
        this.$store.commit('setAuthUser', userStatus);
      })

      this.mounted = true;


  },

  data: function(){
      return {
        mounted: false
      }
  },

  computed: {
    isAuthenticated: function(){
      return this.$store.getters.isAuthenticated;
    },

    breadcrumbs: function(){
      let pathArray = this.$route.path.split("/");

      

      pathArray.shift();

      if(pathArray.length && (pathArray[pathArray.length - 1] == "")){
        pathArray.pop();
      }

      var basePath = "/";
      let links = pathArray.map((fragment) => {

        
        
        basePath = (basePath + fragment + "/");

        return {
          label: fragment,
          path: basePath
        }
      })

      console.log(links);
      return links;

    }
  },

  methods: {
    logout: function(){
            console.log("logout");
            this.showOptions = false;
            this.$router.push({name: "home"}).catch(err => {});
            this.$api.removeToken();
            this.$store.dispatch("logout");
            

        },
  }
}
</script>



<style>

table tbody .striped {
  /* @apply border-b; */
}

table tbody .striped:nth-child(odd) {
    /* @apply bg-gray-100; */
}

</style>
